import _ from 'lodash';
import { ANNOTATION_TYPE } from '../../../config';

type SampleMarkInstance = {
  type: any;
  canvasChart: any;
  ctxChart: any;
  config: any;
  verticalChannelPlacement: any;
  displayedChannelsArr: any;
  pixelSamples: any;
  channelIndex: any;
  startSample: any;
  endSample: any;
  sampleMarkRange: any;
  halfBccHeight: any;
  startY: any;
  endY: any;
};

let SampleMark;

(function () {
  SampleMark = function (
    this: SampleMarkInstance,
    canvasChart: any,
    verticalChannelPlacement: any,
    config: any,
    displayedChannelsArr: any,
    pixelSamples: any,
    sampleMark: any,
  ) {
    this.type = ANNOTATION_TYPE.SAMPLE_MARK;
    this.canvasChart = canvasChart;
    this.ctxChart = this.canvasChart.getContext('2d');
    this.config = config;
    this.verticalChannelPlacement = verticalChannelPlacement;
    this.displayedChannelsArr = displayedChannelsArr;
    this.pixelSamples = pixelSamples;
    this.channelIndex = sampleMark.channelIndex;
    this.startSample = sampleMark.startSample;
    this.endSample = sampleMark.endSample;
    this.sampleMarkRange = sampleMark.sampleMarkRange;
  };

  SampleMark.prototype.drawOneSampleMark = function (
    this: SampleMarkInstance,
    offsetX: any,
    strokeStyle: any,
  ) {
    const { sampleLength, numberOfVisibleChannels, height } = this.config;

    this.ctxChart.beginPath();
    this.ctxChart.strokeStyle = strokeStyle;
    this.halfBccHeight = height / 2 / numberOfVisibleChannels;

    if (this.endSample >= sampleLength) {
      this.endSample = sampleLength - 1;
      this.sampleMarkRange = this.endSample - this.startSample;
    }

    if (this.startSample < 0) {
      this.startSample = 0;
      this.sampleMarkRange = this.endSample - this.startSample;
    }

    _.forEach(this.displayedChannelsArr, (element, index) => {
      if (this.channelIndex === element) {
        this.startY = this.verticalChannelPlacement[index] - this.halfBccHeight;
        this.endY = this.verticalChannelPlacement[index] + this.halfBccHeight;

        // draw first vertical line
        this.ctxChart.moveTo(
          this.pixelSamples[index][this.startSample].x - this.pixelSamples[index][offsetX].x,
          this.startY,
        );
        this.ctxChart.lineTo(
          this.pixelSamples[index][this.startSample].x - this.pixelSamples[index][offsetX].x,
          this.endY,
        );

        // draw last vertical line
        this.ctxChart.moveTo(
          this.pixelSamples[index][this.endSample].x - this.pixelSamples[index][offsetX].x,
          this.startY,
        );
        this.ctxChart.lineTo(
          this.pixelSamples[index][this.endSample].x - this.pixelSamples[index][offsetX].x,
          this.endY,
        );

        // draw sample mark line
        for (
          let j = Math.min(this.startSample, this.endSample);
          j < Math.max(this.startSample, this.endSample);
          j += 1
        ) {
          if (j < this.config.sampleLength) {
            // out-range conditional
            this.ctxChart.moveTo(
              this.pixelSamples[index][j].x - this.pixelSamples[index][offsetX].x,
              this.pixelSamples[index][j].y,
            );
            this.ctxChart.lineTo(
              this.pixelSamples[index][j + 1].x - this.pixelSamples[index][offsetX].x,
              this.pixelSamples[index][j + 1].y,
            );
          } else {
            break;
          }
        }
      }
    });
    this.ctxChart.stroke();
    this.ctxChart.closePath();
  };

  SampleMark.prototype.update = function (
    this: SampleMarkInstance,
    pixelSamples: any,
    config: any,
    displayedChannelsArr: any,
    verticalChannelPlacement: any,
  ) {
    this.pixelSamples = pixelSamples;
    this.config = config;
    this.displayedChannelsArr = displayedChannelsArr;
    this.verticalChannelPlacement = verticalChannelPlacement;
  };

  SampleMark.prototype.getJSONObject = function (this: SampleMarkInstance) {
    return {
      type: this.type,
      channelIndex: this.channelIndex,
      startSample: this.startSample,
      endSample: this.endSample,
      sampleMarkRange: this.sampleMarkRange,
    };
  };
})();

export { SampleMark };
export default { SampleMark };
